<style>
  .pl-70{
    padding-left: 70px !important;
  }
  .pl-95{
    padding-left: 95px !important;
  }
  .rt-11{
    margin-top: -11px;
  }
  </style>
<div class="content">
	<div class="content-wrap">
		<hhsg-message-bar [messages]="errorMessages" [isError]="true"></hhsg-message-bar>
    <hhsg-page-header headerText="New Notification" subHeaderText="" [showBreadCrumb]="true" [displayDivider]="false" class="admin-header">
      </hhsg-page-header>
        <div class="content-inner">
            <div class="inner-border">
                <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                  <div formGroupName ="to">
                          <div class="d-flex">
                            <span class="label rad">To</span>
                          </div>
                          <div class="form-group pb-05 pl-3 mt-n3 ml-17">
                            <div class="row my-1">
                                <input type="radio" class="mr-1" formControlName="receiver" name="receiver" id="receiver" value="All Users" (change)="onRadioChanged($event)">
                                <label for="alluser">All Users</label>
                            </div>
                          </div>
                          <div class="form-group pb-05 pl-3 ml-17">
                            <div class="row my-1">
                                <input type="radio" class="rt-11" id="receiver" formControlName="receiver" name="receiver" value="Client" (change)="onRadioChanged($event)">
                                <label for="client" class="mx-2 mr-2">Client</label>
                                <lib-searchable-single-selectbox formControlName="receiverClient" class="cli-dd" [dataSource]="clientsDataSource" (selectedId)="setSelectedClientId($event)"
                                [isRequired]="isEmailFieldRequired"></lib-searchable-single-selectbox>
                             </div>
                             <span class="validation-error pl-3 mx-1 pl-70 ml-23"  *ngIf="showErrorMessage">Please select client.</span>
                            </div>
                          <div class="form-group pb-2 pl-3 ml-17">
                            <div class="row my-1 pos-rel">
                                <input type="checkbox" class="algn-slf" id="emailCheckBox" formControlName="emailCheckBox" name="emailCheckBox" value="false" (change)="onRecipientChanged($event)" >
                                <label for="email" class="mx-2 mr-2">Recipient</label>
                                <lib-searchable-multi-selectbox #searchableMultiSelectbox formControlName="receiverEmail" name="receiverEmail" id="receiverEmail" [dataSource]="emails" [checkBoxChangeValue]="isRecipientCheckedChanged"
                                (showErrorMessage) ="setShowErrorMessage($event)" [isRequired]="isRecipientFieldRequired" [isNotNoDataText]="true"
                                (onInput)="onRecipientInput($event)" (onOutsideClick)="onRecipientOutsideClick($event)"
                                (resetControl)="resetRecipientControl()"></lib-searchable-multi-selectbox>
                            </div>
                            <span  class="validation-error pl-3 mx-1 pl-95" *ngIf="showEmailErrorMessage">Please select recipient.</span>
                          </div>
                        </div>
                    <div class="form-group">
                        <div class="row">
                          <span class="label mr-1 ml-1">Title</span>
                          <input type="text" placeholder="" formControlName="title" name="title" class="ml-0" style="width: 582px;"
                          (change)="trimValue('title')" [ngClass]="{'is-invalid': formGroup.get('title').errors}">
                        </div>
                        <span  class="validation-error pl-4 mx-1" *ngIf="showError(formGroup.get('title').value.trim())">Title is required.</span>
                        <span class="validation-error pl-4 mx-1" *ngIf="formGroup.get('title').errors?.['maxlength']">Title is too long.</span>
                      </div>
                        <div formGroupName ="message" class="form-group">
                          <span class="label mr-1 mb-1" >Message</span>
                          <div class="row mb-1">
                            <input type="radio" id="templateType" formControlName="templateType" value="Template" (change)="getEmailTemplateBody()">
                            <label for="template" class="mr-3">Template</label>
                            <input type="radio" id="templateType" formControlName="templateType" value="Customize" (change)="resetEmailTemplateBody()">
                            <label for="customize" class="mr-3">Customize</label>
                            <div class="checkbx-group1">
                              <input type="checkbox" id="highPriority" formControlName="highPriority" value="High Priority">
                              <label for="HighPriority">High Priority</label>
                            </div>
                          </div>
                            <lib-rich-text-box formControlName="messageBox" (showMessageBoxError)="setShowMessageBoxError($event)"
                            [isRequired]="isMessageFieldRequired"></lib-rich-text-box>
                            <span  class="validation-error mx-1" *ngIf="showMessageBoxError">Message is required.</span>
                        </div>

                </form>
            </div>
        </div>
        <div class="foot-btngrp">
            <div class="button-grp">
                <button class="btn-primary" (click)="onSubmit()" [disabled]="!isFormValid">Send Notification</button>
                <button class="btn-default" (click)="onCancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<hhsg-shared-modal  [(isActive)]="_notificationService.confirmSaving" (acceptEvent)="onConfirmSaving()"
           (rejectEvent)="_notificationService.confirmSaving = false" [disableFooter]="false" [disableHeader]="true"
           acceptText="Yes" type="small" rejectText="No">
  <div role="body">
    Do you want to send this notification?
  </div>
</hhsg-shared-modal >
<hhsg-shared-modal  [(isActive)]="displayDeactivation" (acceptEvent)="onDeactivateLeavePage()"
           (rejectEvent)="onDeactivateContinueEditing()" [disableFooter]="false" [disableHeader]="true">
  <div role="body">
    <div>* You have unsaved changes. Do you want to leave this page?</div>
  </div>
  <div role="footer">
    <div class="button-grp pl-1">
      <button class="btn-primary mt-1" (click)="onDeactivateContinueEditing()">Continue Editing</button>
      <button type="submit" class="btn-default mt-1" (click)="onDeactivateLeavePage()">Leave Page</button>
    </div>
  </div>
</hhsg-shared-modal >



